export const administrationPermissions = {
    List: 6000,
    Create: 6001,
    Update: 6002,
    ShowDetails: 6003,
    Delete: 6004,
    LockUnLock: 6005,
}
export const jobGradePermissions = {
    List: 10000,
    Create: 10001,
    Update: 10002,
    ShowDetails: 10003,
    Delete: 10004,
}
export const departmentPermissions = {
    List: 7000,
    Create: 7001,
    Update: 7002,
    ShowDetails: 7003,
    Delete: 7004,
    LockUnLock: 7005,
}
export const UnitPermissions = {
    List: 25000,
    Create: 25001,
    Update: 25002,
    ShowDetails: 25003,
    Delete: 25004,
    LockUnLock: 25005,
}
export const userPermissions = {
    List: 9000,
    Create: 9001,
    Update: 9002,
    ShowDetails: 9003,
    Delete: 9004,
    LockUnLock: 9005,
    ResetPassword: 9006,
}
export const auditLogPermissions = {
    List: 33000,
    Export: 33001,
}

// Organisation identity: name, contact details and logo (feature 39).
export const organizationPermissions = {
    View: 39000,
    Update: 39001,
};
